export default __webpack_public_path__ + "static/media/18-keep fit.272f3a7b.svg";